import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import { secretKey } from "./data";
import Loading from "./loading.js";
import { faEdit, faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MySwal = withReactContent(Swal2);

const RankDataPopUpUser = (props) => {
  const [loading, setLoading] = useState(false);
  const [rankData, setRankData] = useState(props.rankData);
  const [rankDataClear, setRankDataClear] = useState(props.rankData);
  const [filterSeller, setFilterSeller] = useState("");
  const [filterClient, setFilterClient] = useState("");

  const onlyUnique = (value, index, array) => {
    return array.indexOf(value) === index;
  };

  const fetchAddData = async (e) => {
    var body = {
      sellerName: "",
      aggrValue: "",
      aggrSF: "",
      clientName: "",
      aggrType: "",
      sfType: "",
      department: "",
      dateRank:
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1) +
        "-" +
        (new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate()),
      aggrValueCourt: "",
    };

    await fetch("https://apisplit.ftpeople.pl/addRankData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "HIUHS9820lssj)@(!0",
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        props.close();
      })
      .catch((error) => {});
  };

  const fetchDeleteRank = async (e) => {
    var body = {
      id: e.currentTarget.value,
    };

    await fetch("https://apisplit.ftpeople.pl/deleteRankData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        props.close();
      })
      .catch((error) => {});
  };

  const fetchEditRank = async (id, field, value) => {
    var body = { id: id, field: field, value: value };

    await fetch("https://apisplit.ftpeople.pl/editRank", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        props.close();
      })
      .catch((error) => {});
  };

  const editRank = (e) => {
    var id = e.currentTarget.value;
    var field = e.currentTarget.id;
    var valueP = e.currentTarget.attributes.fieldValue.value;

    MySwal.fire({
      title: "Zmiana",
      input: "text",
      inputValue: valueP,
      cancelButtonText: "Anuluj",
      inputLabel: "nowa wartość",
      showCancelButton: true,
      inputValidator: (value) => {
        fetchEditRank(id, field, value);
      },
    });
  };

  const handleFilterChange = (value, mode, data) => {
    var arr = data;

    var fText = mode === "filterSeller" ? value : filterSeller;
    if (filterSeller.length > 0 || mode === "filterSeller") {
      arr = arr.filter((el) => el.sellerName.includes(fText));
    }

    var fText = mode === "filterClient" ? value : filterClient;
    if (filterClient.length > 0 || mode === "filterClient") {
      arr = arr.filter((el) => el.clientName.includes(fText));
    }

    setRankData(arr);
  };

  const handleChangeFilterSeller = (e) => {
    setFilterSeller(e.target.value);
    handleFilterChange(e.target.value, "filterSeller", rankDataClear);
  };

  const handleChangeFilterClient = (e) => {
    setFilterClient(e.target.value);
    handleFilterChange(e.target.value, "filterClient", rankDataClear);
  };

  const clearFilters = () => {
    setFilterSeller("");
    setFilterClient("");
    handleFilterChange("", "", rankDataClear);
  };

  const editRankData = (
    <>
      {rankData.length === 0 ? (
        ""
      ) : (
        <>
          <table className="clients_table" style={{ width: "100%" }}>
            <tr>
              <th>ID</th>
              <th>Handlowiec</th>
              <th>Wartość umowy</th>
              <th>Wartość success fee</th>
              <th>Rodzaj success fee</th>
              <th>E-mail klienta</th>
              <th>Imię i nazwisko klienta</th>
              <th>Rodzaj umowy</th>
              <th>Dział</th>
              <th>Data</th>
            </tr>
            {rankData.map((rank, index) => (
              <>
                <tr
                  style={
                    rank.cancel === "1"
                      ? { backgroundColor: "red", color: "white" }
                      : { backgroundColor: "white", color: "black" }
                  }
                >
                  <td>{rank.id}</td>
                  <td>{rank.sellerName}</td>
                  <td>{rank.aggrValue}</td>
                  <td>{rank.aggrSF}</td>
                  <td>{rank.sfType}</td>
                  <td>{rank.clientName}</td>
                  <td>{rank.clientNameFull}</td>
                  <td>{rank.aggrType}</td>
                  <td>{rank.department}</td>
                  <td>{rank.date}</td>
                </tr>
              </>
            ))}
          </table>
        </>
      )}
    </>
  );

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div
            style={{
              backgroundColor: "white",
              top: "0",
              paddingTop: "5vh",
              paddingBottom: "3vh",
              paddingLeft: "2vw",
              paddingRight: "2vw",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "left",
                alignItems: "end",
                gap: "1vw",
              }}
            >
              <div style={{ width: "180px", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "2px",
                    fontWeight: "600",
                    fontSize: ".6vw",
                    paddingLeft: "2px",
                  }}
                >
                  klient
                </p>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                    height: "3vh",
                  }}
                  value={filterClient}
                  onChange={handleChangeFilterClient}
                />
              </div>
              <button
                className="loginButtonLogin"
                value="yes"
                style={{
                  margin: "0",
                  backgroundColor: "navy",
                  borderColor: "navy",
                  width: "180px",
                  height: "3vh",
                }}
                onClick={clearFilters}
              >
                WYCZYŚĆ FILTR
              </button>
              <button
                className="loginButtonLogin"
                value="yes"
                style={{
                  margin: "0",
                  backgroundColor: "red",
                  borderColor: "red",
                  width: "180px",
                  height: "3vh",
                }}
                onClick={props.close}
              >
                ZAMKNIJ
              </button>
            </div>
          </div>
          <div
            style={{
              paddingLeft: "2vw",
              paddingBottom: "5vh",
            }}
          >
            {rankData.length === 0 ? (
              <p style={{ textAlign: "left" }}>BRAK DANYCH RANKINGOWYCH</p>
            ) : (
              <>{editRankData}</>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default RankDataPopUpUser;
